// =============================================================================
// CANVAS CONFIG - Shared design tokens and dimensions
// =============================================================================

export const LOGO_PATH = '/logo.png';

export const CARD_DIMENSIONS = {
  width: 1080,
  height: 1350,
} as const;

export const STORIES_DIMENSIONS = {
  width: 1080,
  height: 1920,
} as const;

export const COLORS = {
  background: '#0a0e14',
  backgroundAlt: '#0d1218',
  primary: '#10b981',
  primaryDim: 'rgba(16, 185, 129, 0.3)',
  text: '#e5e7eb',
  textDim: '#6b7280',
  warning: '#f59e0b',
  critical: '#ef4444',
  success: '#22c55e',
  border: '#1f2937',
} as const;
